import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'network/api';

type PipeReviewPayload = {
  status: 'APPROVED' | 'REJECTED';
  mrvResourceId: string;
  type: string;
  reason: string;
};

type MutationConfig = {
  onError?: () => void;
  onSuccess?: () => void;
  onFinish?: () => void;
};

const updatePipe = async (data: PipeReviewPayload) => {
  try {
    const res = await API.post('mrvresources/review', data);
    return res?.data || [];
  } catch (error: Error | unknown) {
    if (error instanceof Error) throw new Error(error.message);
    throw new Error('Something went wrong');
  }
};

const useUpdatePipeMutation = (config?: MutationConfig) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error, isError } = useMutation({
    mutationFn: updatePipe,
    onError: () => config?.onError?.(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['pipe-list'],
      });
      config?.onSuccess?.();
    },
    onSettled: () => config?.onFinish?.(),
  });

  return {
    mutate: mutateAsync,
    isLoading: isPending,
    error,
    isError,
  };
};

export default useUpdatePipeMutation;
